import { render, staticRenderFns } from "./narrative-section-modal.vue?vue&type=template&id=6f94d0a5"
import script from "./narrative-section-modal.vue?vue&type=script&lang=js"
export * from "./narrative-section-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports